import React from "react";
import BlogList from "../blog/blogList";
import Topnavbar from "../components/navbar";
import Footer from "../components/footer";

const Blog = ({ isLoading }) => {
  return (
    <div>
      <Topnavbar />
      <div className="container mx-auto py-8">
      <h1 className="text-3xl font-bold mb-8">My Blog posts</h1>
      <BlogList isLoading={isLoading} />
    </div>
      <Footer />
    </div>
  );
};

export default Blog;

